module.exports = __webpack_public_path__ + "media/images/file-icons/512/007-folder-32a4211ee0f3e23a72da147a1be368cb.png";